/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './blood-bank-inventory.reducer';

export const BloodBankInventory = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const bloodBankInventoryList = useAppSelector(state => state.bloodBankInventory.entities);
  const loading = useAppSelector(state => state.bloodBankInventory.loading);
  const totalItems = useAppSelector(state => state.bloodBankInventory.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="blood-bank-inventory-heading" data-cy="BloodBankInventoryHeading">
        <Translate contentKey="tinyMedicRestApp.bloodBankInventory.home.title">Blood Bank Inventories</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.bloodBankInventory.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/blood-bank-inventory/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.bloodBankInventory.home.createLabel">Create new Blood Bank Inventory</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.bloodBankInventory.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {bloodBankInventoryList && bloodBankInventoryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('bloodBagNumber')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.bloodBagNumber">Blood Bag Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodBagNumber')} />
                </th>
                <th className="hand" onClick={sort('bloodType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.bloodType">Blood Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodType')} />
                </th>
                <th className="hand" onClick={sort('rhType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.rhType">Rh Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rhType')} />
                </th>
                <th className="hand" onClick={sort('productType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.productType">Product Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productType')} />
                </th>
                <th className="hand" onClick={sort('collectionDate')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.collectionDate">Collection Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('collectionDate')} />
                </th>
                <th className="hand" onClick={sort('expiryDate')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.expiryDate">Expiry Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expiryDate')} />
                </th>
                <th className="hand" onClick={sort('storageLocation')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.storageLocation">Storage Location</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('storageLocation')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('volume')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.volume">Volume</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('volume')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.validator">Validator</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.bank">Bank</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.donation">Donation</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.status">Status</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.productComponent">Product Component</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankInventory.donationApproval">Donation Approval</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bloodBankInventoryList.map((bloodBankInventory, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/blood-bank-inventory/${bloodBankInventory.id}`} color="link" size="sm">
                      {bloodBankInventory.id}
                    </Button>
                  </td>
                  <td>{bloodBankInventory.bloodBagNumber}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BloodGroup.${bloodBankInventory.bloodType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.RhType.${bloodBankInventory.rhType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BloodProducts.${bloodBankInventory.productType}`} />
                  </td>
                  <td>{bloodBankInventory.collectionDate}</td>
                  <td>{bloodBankInventory.expiryDate}</td>
                  <td>{bloodBankInventory.storageLocation}</td>
                  <td>{bloodBankInventory.active ? 'true' : 'false'}</td>
                  <td>{bloodBankInventory.cursor}</td>
                  <td>{bloodBankInventory.lastUpdated}</td>
                  <td>{bloodBankInventory.microSec}</td>
                  <td>{bloodBankInventory.timestampEntry}</td>
                  <td>{bloodBankInventory.volume}</td>
                  <td>{bloodBankInventory.notes}</td>
                  <td>
                    {bloodBankInventory.validator ? (
                      <Link to={`/blood-bank-employee/${bloodBankInventory.validator.id}`}>{bloodBankInventory.validator.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodBankInventory.bank ? (
                      <Link to={`/blood-bank/${bloodBankInventory.bank.id}`}>{bloodBankInventory.bank.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodBankInventory.donation ? (
                      <Link to={`/blood-donation/${bloodBankInventory.donation.id}`}>{bloodBankInventory.donation.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodBankInventory.status ? (
                      <Link to={`/clinical-dictionary/${bloodBankInventory.status.id}`}>{bloodBankInventory.status.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodBankInventory.productComponent ? (
                      <Link to={`/clinical-dictionary/${bloodBankInventory.productComponent.id}`}>
                        {bloodBankInventory.productComponent.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodBankInventory.donationApproval ? (
                      <Link to={`/clinical-dictionary/${bloodBankInventory.donationApproval.id}`}>
                        {bloodBankInventory.donationApproval.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/blood-bank-inventory/${bloodBankInventory.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/blood-bank-inventory/${bloodBankInventory.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/blood-bank-inventory/${bloodBankInventory.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.bloodBankInventory.home.notFound">No Blood Bank Inventories found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={bloodBankInventoryList && bloodBankInventoryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default BloodBankInventory;
